const delete_support_flg = {
    development: ["CUS0000003D"],
    staging: ["CUS0001084G"],
    production: ["CUS0000890L"],
}

export default delete_support_flg[process.env.REACT_APP_MODE] 
